import { ElementRef } from "@angular/core"

export interface StickyNavbar {
    /*
     * Height of the navbar
     */
    height: number

    /*
     * Shows the navbar
     */
    show: () => void

    /*
     * Hides the navbar
     */
    hide: () => void

    /*
     * Gets called when a new trigger is activated
     */
    update: (trigger: StickyNavbarTrigger) => void
}

export class StickyNavbarContent {
    height: number
    /*
     * Called by StickyNavbar when a new trigger is activated
     */
    update: (trigger: StickyNavbarTrigger) => void
}

export interface StickyNavbarTrigger {
    triggerElementRef: ElementRef
    triggerId: string
}
